import { render, staticRenderFns } from "./imageVideoComponent.vue?vue&type=template&id=25bef7df&"
import script from "./imageVideoComponent.vue?vue&type=script&lang=js&"
export * from "./imageVideoComponent.vue?vue&type=script&lang=js&"
import style0 from "./imageVideoComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports